import cn from "classnames";
import { useRef } from "react";

import data from "@constants/best-in-travel/2025";

import { useBestInTravel } from "@context/bestInTravel/2025/bestInTravelContext";
import { normalizeShareData } from "@utils/bestInTravel/2025/normalizeShareData";

import { CloseX } from "@icons/closeX";
import { Share } from "@pageComponents/best-in-travel-2025/share";

export function ShareDrawer() {
  const { shareDrawerOpen, setShareDrawerOpen, shareData } = useBestInTravel();
  const drawerRef = useRef(null);

  return (
    <div className="relative z-50 bg-black no-scrollbar">
      <div
        className={cn(
          "fixed top-0 w-full h-screen-dvh bg-black/40 z-20 transition-all",
          {
            invisible: !shareDrawerOpen,
          }
        )}
      >
        <div
          ref={drawerRef}
          className={cn("absolute top-full w-full transition-transform", {
            "-translate-y-full": shareDrawerOpen,
          })}
        >
          <div className="relative max-w-3xl p-6 mx-auto bg-white rounded-t-lg shadow">
            <button
              type="button"
              className="absolute z-10 flex items-center justify-center w-10 h-10 border rounded-full top-6 right-4 border-black-300 bg-black-100"
              onClick={() => setShareDrawerOpen(false)}
            >
              <CloseX className="inline-block" />
            </button>

            <Share
              data={shareData ? normalizeShareData(data, shareData) : null}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
